/**
 * Settings Form Component
 */

import { type ReactElement } from 'react';
import { GitCredentialsSection } from './GitCredentialsSection';

export function SettingsForm(): ReactElement {
  return (
    <div className="settings-form">
      <GitCredentialsSection />
    </div>
  );
}
